/*
  Franja Flash Deals del navbar (<site-flash-strip>): la arma snippets/site-flash-strip.liquid, los estilos van en ese snippet.
  Cada instancia se arma sola al conectarse (también cuando el editor del theme vuelve a renderizar el navbar).
  · Mensajes: rotan cada data-interval segundos. El que sale sube y se desvanece, el que entra sube desde abajo. Se frena
    con el mouse encima y con la pestaña oculta; con un solo mensaje no hace nada.
  · Cuenta regresiva: a data-end (con zona horaria, o la hora local del visitante si no la lleva). Muestra todas las horas
    (75:35:24); los dígitos que cambian saltan con la receta number-pop-in (la define u1.css). Al llegar a cero la franja se
    esconde con la misma animación que la franja de campaña (.is-hidden).
*/
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
const pad = n => String(n).padStart(2, '0');

class SiteFlashStrip extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.strip = this.querySelector('.site-flash-strip');
    this.initMessages();
    this.initTimer();
  }

  disconnectedCallback() {
    clearTimeout(this._msgT);
    clearTimeout(this._tickT);
    document.removeEventListener('visibilitychange', this._onVis);
    this._ready = false;
  }

  /* ───────── Mensajes ───────── */
  initMessages() {
    const msgs = [...this.querySelectorAll('[data-sfs-msg]')];
    if (msgs.length < 2) return;
    const every = Math.max(2, Number(this.dataset.interval) || 4) * 1000;
    let i = 0;
    let hover = false;

    const show = next => {
      const from = msgs[i];
      const to = msgs[next];
      from.classList.remove('is-on', 'is-in');
      from.classList.add('is-out');
      from.setAttribute('aria-hidden', 'true');
      to.classList.remove('is-out');
      to.classList.add('is-on', 'is-in');
      to.removeAttribute('aria-hidden');
      i = next;
    };
    const tick = () => {
      if (!hover && !document.hidden) show((i + 1) % msgs.length);
      this._msgT = setTimeout(tick, every);
    };
    const start = () => { clearTimeout(this._msgT); this._msgT = setTimeout(tick, every); };

    this.strip.addEventListener('pointerenter', () => { hover = true; });
    this.strip.addEventListener('pointerleave', () => { hover = false; start(); });
    this._onVis = () => { if (!document.hidden) start(); };
    document.addEventListener('visibilitychange', this._onVis);
    start();
  }

  /* ───────── Cuenta regresiva ───────── */
  initTimer() {
    const timer = this.querySelector('[data-sfs-timer]');
    const digits = this.querySelector('[data-sfs-digits]');
    if (!timer || !digits) return;
    const end = new Date(this.dataset.end).getTime();
    if (Number.isNaN(end)) { timer.hidden = true; return; }
    let shown = '';
    let minute = -1;

    const paint = str => {
      let same = 0;
      while (same < shown.length && same < str.length && shown[same] === str[same]) same++;
      const live = !!shown && !reduce.matches;
      digits.classList.remove('is-animating');
      digits.replaceChildren(...[...str].map((ch, k) => {
        const el = document.createElement('span');
        el.className = 't-digit' + (ch === ':' ? ' is-sep' : '');
        el.textContent = ch;
        if (k < same) el.dataset.same = '';
        if (k === str.length - 2) el.dataset.stagger = '1';
        else if (k === str.length - 1) el.dataset.stagger = '2';
        return el;
      }));
      timer.removeAttribute('data-pending');
      if (!live) return;
      void digits.offsetHeight;
      digits.classList.add('is-animating');
    };

    const tick = () => {
      const left = Math.max(0, end - Date.now());
      const r = Math.floor(left / 1000);
      const h = Math.floor(r / 3600);
      const m = Math.floor(r / 60) % 60;
      const str = `${pad(h)}:${pad(m)}:${pad(r % 60)}`;
      if (str !== shown) { paint(str); shown = str; }
      if (m !== minute) { minute = m; timer.setAttribute('aria-label', timer.dataset.u1LEnds ? timer.dataset.u1LEnds.replace('__H__', h).replace('__M__', m) : `Ends in ${h} h ${m} min`); }
      if (left === 0) { this.strip.classList.add('is-hidden'); return; }
      /* el próximo tick cae justo cuando cambia el segundo */
      this._tickT = setTimeout(tick, (left % 1000) + 5);
    };
    tick();
  }
}

if (!customElements.get('site-flash-strip')) customElements.define('site-flash-strip', SiteFlashStrip);
